module.exports = __webpack_public_path__ + "static/media/database.c5a0a7d4.svg";